export default {
  businessLogisticsCompanyFreight: {
    header: {
      templateName: 'Template Name',
      businessName: 'Courier Service Name',
      applicableWarehouse: 'Applicable Warehouse'
    },
    table: {
      templateName: 'Template Name',
      ApplicableLogistics: 'Applicable Logistics Business',
      applicableWarehouse: 'Applicable Warehouse',
    },
    // 新增页面
    Add: {
      essentialInformation: 'Account Information',
      templateName: 'Template Name',
      description: 'Description',
      costPriority: 'Cost Calculation Priority',
      billingByWeightIsPreferred: 'Charge by weight first',
      billingByVolumePriority: 'Charge by volume first',
      setConversionFormula: 'Set volume-to-weight conversion formula',
      receivingAreaCostStandard: 'Receiving area cost standard',
      addedStandardCharge: 'Added Standard Charge',
      area: 'Region',
      editArea: 'Edit Region',
      singleQuantity: 'Order quantity / month',
      unlimited: 'Unlimited',
      parcelWeightRange: 'Package weight range (including first weight)',
      chargeMode: 'Billing Method',
      cost: 'Cost',
      dollar: 'CNY',
      increaseRange: 'Add Range',
      addLine: 'Add Row',
      deleteRow: 'Delete Row',
      claimStandard: 'Compensation standard',
      damagePriceStandard: 'Damage Price Standard:',
      priceStandardForLostItems: 'Lost package price standard',
      freeOdds: 'Deductible Ratio',
      templateApplicableLogistics: 'Applicable logistics business of the template',
      selectBusiness: 'Select Business',
      businessName: 'Courier Service Name',
      affiliatedLogisticsProvider: 'Logistics Provider',
      templateApplicableWarehouse: 'Applicable warehouse of the template',
      selectWarehouse: 'Select Warehouse',
      warehouseCoding: 'Warehouse Code',
      warehouseName: 'Warehouse Name',
      warehouseAddress: 'Warehouse Address',
      setVolume: 'Set Volume',
      volumeFormula: 'Volume weight calculation formula = Length(cm) × Width(cm) × Height(cm) /',
      templateNameText: 'Please enter template name',
      LogisticsName: 'Logistics Provider Name',
      callbackErrorText: 'Please enter a positive integer value between 0 and 100',
      singleQtyErrMsg: 'Order quantity',
      weightRange: 'Weight range',
      msgWarning1: 'Please select a logistics service',
      left: 'Left',
      leftText: 'Must be less than right',
      right: 'Right',
      rightText1: 'incorrect input',
      rightText2: 'Must be greater than left',
      msgWarning2: 'Please select a logistics service first',
    }
  }
};
